

<template>
  <div id="date-tip-modal">
    <visa-dialog :show="showDateTip" :widthClass="'width400'" @visibleSync="modalVisibleSync" :titleInfo="dateTipType === 1 ? '有效期提醒' : '温馨提示'">
      <div v-if="dateTipType === 1" class="content">
        申请人【
        <span class="tip-name">{{applicantNames}}</span>】出行日期距离护照有效期已不足6个月，暂不支持办理签证，请更换新护照后重新提交。
      </div>
      <div v-if="dateTipType === 2" class="content">
        申请人【
        <span class="tip-name">{{applicantNames}}</span>
        】出行日期距离护照有效期不足7个月，请注意提醒出行人离境前有效期需满6个月，本次签证可正常办理出行。
      </div>
      <!-- 底部按钮 -->
      <div v-if="dateTipType === 1" class="footer-box">
        <el-button class="btn-box fill-btn lg" @click="closeDateTip">去修改</el-button>
      </div>
      <div v-if="dateTipType === 2" class="footer-box">
        <el-button class="btn-box fill-btn lg" @click="confirmDateTip">继续办理</el-button>
        <!-- <el-button class="btn-box fill-btn" @click="closeDateTip">去修改</el-button> -->
      </div>
    </visa-dialog>
  </div>
</template>

<script>
import orderingService from '@/services/ordering-service';
import visaDialog from '@/components/common/modals/visa-dialog/visa-dialog';

export default {
  name: 'date-tip-modal',
  components: { visaDialog },
  props: {
    order: {
      type: Object,
      required: true,
      value: null,
    },
    departDate: {
      type: [Date, String],
    },
  },
  data() {
    return {
      showDateTip: false,
      applicantNames: '',
      dateTipType: 1, // 1小于6个月 2小于7个月
      _resolve: undefined,
      _reject: undefined,
    };
  },
  methods: {
    showDateTipInit() {
      return new Promise((resolve, reject) => {

        this._resolve = resolve || function () {};
        this._reject = reject || function () {};
        const applicants = this.order.applicant;
        if (!this.departDate) return resolve();
        const departDateStr = this.departDate.format('yyyy-MM-dd');
        let applicantNames = '';

        // 判断是否有小于6个月的申请人护照
        const limit6 = applicants
          .filter(item =>
            item.applicant_passport && orderingService.withinDate(
              departDateStr,
              item.applicant_passport.expire_date,
              6,
            ),
          )
          .map(item => item.applicant_name);
        if (limit6.length > 0) {
          if (limit6.length > 3) {
            applicantNames = `${limit6.slice(0, 3).join('、')}等`;
          } else {
            applicantNames = limit6.join('、');
          }
          this.showDateTip = true;
          this.dateTipType = 1;
          this.applicantNames = applicantNames;
          return;
        }

        // 判断是否有小于7个月的申请人护照
        const limit7 = applicants
          .filter(item =>
            item.applicant_passport && orderingService.withinDate(
              departDateStr,
              item.applicant_passport.expire_date,
              7,
            ),
          )
          .map(item => item.applicant_name);
        if (limit7.length > 0) {
          if (limit7.length > 3) {
            applicantNames = `${limit7.slice(0, 3).join('、')}等`;
          } else {
            applicantNames = limit7.join('、');
          }
          this.showDateTip = true;
          this.dateTipType = 2;
          this.applicantNames = applicantNames;
          return;
        }

        // 如果距离有效期全都大于七个月，直接下一步
        this.showDateTip = false;
        resolve();
      });
    },
    confirmDateTip() {
      this._resolve();
      this.showDateTip = false;
    },
    closeDateTip() {
      this.showDateTip = false;
      this._reject();
    },
    modalVisibleSync(val) {
      this.showDateTip = val;
    },
  },
};
</script>

<style lang="less">
#date-tip-modal {
  .visa-dialog-modal {
    width: 360px;
    .custom-header {
      font-size: 18px;
    }
    .content {
      padding: 20px 40px;
      font-size: 16px;
      line-height: 1.5;
      color: #333;
      .tip-name {
        color: #ff5a60;
      }
    }
    .footer-box {
      padding: 20px 40px 30px;
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-box {
        width: 50%;
        height: 40px;
        border-radius: 4px;
        font-size: 16px;
        &.plain-btn {
          border: solid 1px #cfcfcf;
          color: #777777;
        }
        &.fill-btn {
          background-color: #5e9be1;
          border: none;
          color: #ffffff;
        }
        &.lg {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/date-tip-modal.vue